import { Lock, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useEntitlements } from '@/hooks/useEntitlements';
import { getUpsellUrl } from '@/config/upsells';

export const PremiumGate = ({ children, appName, productKey = 'apps_premium' }) => {
  const { hasAccess, refresh, loading } = useEntitlements();
  const navigate = useNavigate();

  if (hasAccess(productKey)) {
    return children;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FDFBF7] to-[#E0F7FA] flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-3xl p-8 shadow-2xl border border-slate-100 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-yellow-100/30 to-orange-100/30 pointer-events-none"></div>

          <div className="relative z-10">
            <div className="w-20 h-20 bg-gradient-to-br from-yellow-300 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <Lock className="w-10 h-10 text-yellow-900" />
            </div>

            <h2 className="text-3xl font-bold text-[#2D3748] mb-4">
              Premium feature
            </h2>

            <p className="text-lg text-[#4A5568] mb-6">
              <span className="font-semibold text-[#81B29A]">{appName}</span> is a premium app. Upgrade to unlock all therapeutic tools.
            </p>

            <div className="space-y-3">
              <a
                data-testid="upgrade-to-premium-btn"
                href={getUpsellUrl(productKey)}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full inline-block bg-[#F4A62A] text-[#2D3748] hover:bg-[#DB9111] px-8 py-4 rounded-full font-bold text-lg hover:-translate-y-1 transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                Upgrade to premium
              </a>

              <button
                data-testid="refresh-access-btn"
                onClick={refresh}
                disabled={loading}
                className="w-full bg-white border-2 border-slate-200 text-[#4A5568] px-8 py-3 rounded-full font-semibold hover:bg-slate-50 transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-50"
              >
                <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
                {loading ? 'Checking...' : 'Refresh my access'}
              </button>

              <button
                data-testid="back-to-dashboard-btn"
                onClick={() => navigate('/dashboard')}
                className="w-full bg-white border-2 border-[#81B29A] text-[#81B29A] px-8 py-3 rounded-full font-semibold hover:bg-[#81B29A]/10 transition-all duration-300"
              >
                Back to dashboard
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
